import React, { ReactNode } from 'react';
import { AccountHeaderBlock } from '../../account/AccountHeaderBlock';
import { PlanStateHeaderBlock } from '../../account/PlanStateHeaderBlock';
import { Page2 } from '../../common/Page2';
import { Flexer } from '../../dashboard/elements/LayoutElements';

export type ManageFrameProps = {
    title: string,
    children?: ReactNode,
};

export const ManageFrame = ({ title, children }: ManageFrameProps) => <>
    <Page2.Header>
        <Page2.Title>
            {title}
        </Page2.Title>
        <Page2.HeaderRight>
            <PlanStateHeaderBlock />
            <AccountHeaderBlock />
        </Page2.HeaderRight>
    </Page2.Header>
    <Page2.Content>
        {children}
        <Flexer height="6" />
    </Page2.Content>
</>;
